






































import Vue, { PropType } from 'vue';
import { currencyFormat, currencyFormatWithDivisor } from '../../../helpers/stats-utils';

export default Vue.extend({
  name: 'CustomerInvoiceCard',
  props: {
    invoice: {
      type: Object as PropType<any>,
    },
  },
  data() {
    return {};
  },
  computed: {
    invoiceDescription(): string {
      if (this.invoice.status === 'paid') {
        return `Paid ${currencyFormatWithDivisor(this.invoice.amountPaid, this.invoice.currency)}`;
      }
      if (this.invoice.status === 'open') {
        return `Due ${currencyFormatWithDivisor(this.invoice.amountDue, this.invoice.currency)}`;
      }
      return `${this.invoice.status}: ${currencyFormatWithDivisor(this.invoice.amountDue, this.invoice.currency)}`;
    },
  },
});
